export class PaymentModel {
  name: string;
  image: string;

  constructor(){
    this.name = "";
    this.image = "";
  }
}
